export { default } from './component';
export { useCardFooter } from './hook';
